export default "__VITE_ASSET__CG9CeZWU__"